abstract class JsonSerializable {
    public static readonly includedFieldsKey = "includedFields";
    public static readonly excludedFieldsKey = "excludedFields";

    private includedFields: string[];
    private excludedFields: string[];

    protected constructor(fields?: { includedFields?: string[], excludedFields?: string[] }) {
        this.includedFields = fields?.includedFields ?? [];
        this.excludedFields = (fields?.excludedFields ?? []).concat([JsonSerializable.includedFieldsKey, JsonSerializable.excludedFieldsKey]);
    }

    public toJSON(): object {
        let json = {};
        let fields = this.includedFields.any() ? this.includedFields : Object.keys(this);

        for (const fieldName of fields) {
            if (!this.excludedFields.some(field => field === fieldName))
                json[fieldName] = this[fieldName];
        }

        return json;
    }
}

export { JsonSerializable };
